import React, { CSSProperties, FC, MouseEventHandler, ReactNode } from 'react';
import { Collapse } from 'react-collapse';
import A11yDiv from '../A11yDiv';
import { useTheme } from '../../../hooks/useTheme';
import styles from './Panel.module.css';

export interface PanelProps {
  fixedPanelHeight?: string;
  header: ReactNode;
  children: ReactNode;
  sOuter?: CSSProperties;
  sInner?: CSSProperties;
  onClick?: MouseEventHandler<HTMLDivElement>;
  collapsible?: boolean;
  open?: boolean;
}

const Panel: FC<PanelProps> = ({
  fixedPanelHeight,
  header,
  children,
  sOuter = {},
  sInner = {},
  onClick,
  collapsible = false,
  open = false,
}) => {
  const {
    panelcontainerNoneNone: panelContainerStyle,
    panelbodyNoneNone: panelBodyStyle,
  } = useTheme();

  return (
    <A11yDiv
      className={styles.container}
      onClick={onClick}
      style={{
        ...panelContainerStyle,
        ...sOuter,
        height:
          fixedPanelHeight ??
          panelContainerStyle?.height ??
          sOuter.height ??
          '100%',
      }}
    >
      <div className={styles.headerContainer}>{header}</div>
      {collapsible ? (
        <Collapse isOpened={collapsible ? !!open : true}>
          <div
            className={styles.scrollableContainer}
            style={{ ...panelBodyStyle, ...sInner }}
          >
            {children}
          </div>
        </Collapse>
      ) : (
        <div
          className={styles.scrollableContainerScroll}
          style={{ ...panelBodyStyle, ...sInner }}
        >
          {children}
        </div>
      )}
    </A11yDiv>
  );
};

export default Panel;
